"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.symbol.async-iterator");
require("core-js/modules/es6.symbol");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.to-string");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _two = _interopRequireDefault(require("@/components/upload/two"));
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    upload: _two.default
  },
  data: function data() {
    return {
      sel_depend_type: 0,
      deviceList: [],
      form: {
        open: 0
      },
      aid: this.$route.query.aid,
      factoryList: [],
      rules: {
        code_tag: [{
          required: true,
          message: '请选择设备类型',
          trigger: 'blur'
        }],
        num: [{
          required: true,
          message: '请输入生成二维码的数量',
          trigger: 'blur'
        }],
        factory_id: [{
          required: true,
          message: '请选择工厂',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    deviceNameObj: function deviceNameObj() {
      return this.$store.state.user.deviceNameObj;
    }
  },
  mounted: function mounted() {
    console.log(this.deviceNameObj);
    this.getDeviceList();
    this.getFactory();
  },
  methods: {
    /**
     * 获取设备类型
     */
    getDeviceList: function getDeviceList() {
      var _this = this;
      // this.deviceList = [
      //   {
      //     type_name: '充电宝',
      //     code_tag: 'NO.',
      //     depend_type: 0
      //   },
      //   {
      //     type_name: '密码线',
      //     code_tag: 'LINE:',
      //     depend_type: 1
      //   },
      //   {
      //     type_name: '蓝牙线',
      //     code_tag: 'B-LINE:',
      //     depend_type: 1
      //   },
      //   {
      //     type_name: '密码蓝牙线',
      //     code_tag: 'NB-LINE:',
      //     depend_type: 1
      //   },
      //   {
      //     type_name: '洗衣机',
      //     code_tag: 'TAG_4_1',
      //     depend_type: 4
      //   },
      //   {
      //     type_name: '电吹风',
      //     code_tag: 'TAG_6_1',
      //     depend_type: 6
      //   },
      //   {
      //     type_name: '充电桩',
      //     code_tag: 'TAG_3_1',
      //     depend_type: 3
      //   },
      //   {
      //     type_name: '按摩枕',
      //     code_tag: 'TAG_2_1',
      //     depend_type: 2
      //   },
      //   {
      //     type_name: '套套机（1口）',
      //     code_tag: 'TAG_7_1',
      //     depend_type: 7
      //   },
      //   {
      //     type_name: '套套机（6口）',
      //     code_tag: 'TAG_7_6',
      //     depend_type: 7
      //   }
      // ]
      // return
      this.$get('agentapi/goods/goods_detail_types', {
        limit: 1000
      }).then(function (res) {
        _this.deviceList = res.list;
      });
    },
    /**
     * 获取公司
     */
    getFactory: function getFactory() {
      var _this2 = this;
      this.$get('/SyFactory/getList', {
        limit: 100
      }).then(function (res) {
        res.list.map(function (item) {
          _this2.factoryList.push({
            factory_id: item.factory_id,
            factory_name: item.factory_name,
            support_device_type: item.support_device_type
          });
        });
      });
    },
    /**
     * 点击提交按钮
     */
    onSubmit: function onSubmit() {
      var _this3 = this;
      var params = JSON.parse(JSON.stringify(this.form));
      this.code_num = parseInt(params.num);
      this.$refs['form'].validate(function (valid, object) {
        if (valid) {
          _this3.loadObj = _this3.$loading({
            lock: true,
            text: '生成中，请耐心等待',
            spinner: 'el-icon-loading'
          });
          _this3.createSn(params);
        } else {
          _this3.formErrow(object);
        }
      });
    },
    /**
     * 选择设备类型
     */
    deviceChange: function deviceChange(val) {
      var _iterator = _createForOfIteratorHelper(this.deviceList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.code_tag == val) {
            this.sel_depend_type = item.depend_type;
            this.code_type = item.code_type;
            this.word_end = item.code_letter;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    /**
     * 获取文件流
     */
    getFile: function getFile(file) {
      this.logo = file;
    },
    /**
     * 点击提交创建二维码
     */
    createSn: function createSn(params) {
      var _this4 = this;
      var last = false;
      this.base_code_num = 1000;
      if (params.open == 1) {
        params.force = 0;
        this.base_code_num = 20;
      } else {
        params.force = 1;
      }
      if (this.code_num > this.base_code_num) {
        params.num = this.base_code_num;
        this.code_num = this.code_num - this.base_code_num;
      } else {
        params.num = this.code_num;
        last = true;
      }
      params.site_agent_id = this.aid;
      params.depend_type = this.sel_depend_type;
      if (this.code_type) params.code_type = this.code_type;
      if (this.word_end) params.word_end = this.word_end;
      this.$post('/QRcode/getCodeSnByUnified', params).then(function (res) {
        if (!last) {
          _this4.createSn(params);
        } else {
          _this4.$message({
            message: '生成完成',
            type: 'success'
          });
          _this4.loadObj.close();
        }
      }).catch(function (err) {
        _this4.loadObj.close();
      });
    }
  }
};